import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ValList } from '@/common/val/ValList';
import { DirSaleLineProgProdList } from '@/sc/entities/dirSaleLine/DirSaleLineProgProdList';

export const DirSaleLineDetail = () => {
  const { entityObj } = useEntityMgr();

  // Links the Direct Sale tab to the Direct Sale's own detail page
  const augDirSaleFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntitySelect key="code" fieldDef={fieldToFieldDef.code} />;
  };

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'dirSaleTab',
      label: 'Direct Sale',
      content: <EntityForm entity="DIR_SALE" entityId={entityObj.dirSaleId} augFieldDefs={augDirSaleFieldDefs} />,
    },
    {
      id: 'progProd',
      label: 'Program Products',
      content: <DirSaleLineProgProdList dirSaleLineId={entityObj.id} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="DIR_SALE_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
